import {ConfEnv} from "../../config/config";
import publicRequest from "../../Infra/http/public.request";

export const checkAliasService = async alias => {
  const response = await publicRequest.get(`${ConfEnv.BASE_URL}/public/check-alias?alias=${alias}`);
  return response;
};
